import { VIDEO_QUERY_PARAM, VIDEOS_PATH } from '../model/ui/video-routes';

const LIBRARY_ORDER_PARAMS = ['order_by', 'order_dir', 'offset'];

const isVideosPath = (pathname: string): boolean =>
  pathname === VIDEOS_PATH || pathname.startsWith(`${VIDEOS_PATH}/`);

export const getLibrarySearch = (pathname: string, search: string): string => {
  if (!isVideosPath(pathname)) {
    return '';
  }

  const params = new URLSearchParams(search);
  params.delete(VIDEO_QUERY_PARAM);
  const query = params.toString();

  return query ? `?${query}` : '';
};

export const getVideoDetailsPath = (videoId: string, librarySearch: string) =>
  `${VIDEOS_PATH}/${encodeURIComponent(videoId)}${librarySearch}`;

export const getVideoLibraryPath = (librarySearch: string) =>
  `${VIDEOS_PATH}${librarySearch}`;

export const isVideoLibraryPath = (pathname: string): boolean =>
  pathname === VIDEOS_PATH;

export const getNewestFirstSearch = (search: string): string => {
  const params = new URLSearchParams(search);
  LIBRARY_ORDER_PARAMS.forEach((param) => params.delete(param));
  const query = params.toString();

  return query ? `?${query}` : '';
};
